// @generated da scripts/i18n-sr-cyrl.mjs — NON EDITARE A MANO.
// i18n area 'system' — locale sr-Cyrl-RS: TRASLITTERAZIONE MECCANICA
// di system.sr-Latn-RS.ts (srpska latinica). Ogni modifica va fatta
// sulla locale sr-Latn-RS e poi rigenerata con: node scripts/i18n-sr-cyrl.mjs
// Sidecar anti-stantie: ../meta/system.sr-Cyrl-RS.meta.json.
import type { enUS } from './system'

export const srCyrlRS: typeof enUS = {
  diagnostics: {
    title: 'Дијагностика',
    subtitle: 'Шта не ваља, најгоре прво — исто сочиво као tvirt диагносе',
    reload: 'Поново учитај',
    loadError: 'Дијагнозу није било могуће прочитати',
    exportBundle: 'Извези пакет',
    exportError: 'Пакет није било могуће направити',
    noProblem: 'Нема проблема у прегледаним областима',
    nothingInspected: 'NIŠTA није прегледано — ово није потврда доброг здравља',
    inspected: 'Прегледане',
    notInspected: 'NISU прегледане',
    localHint: 'Локалне области чвора (systemd јединице, јоурнал) читају се само из CLI-ја: tvirt диагносе --ареа лоцал — пут кад API не одговара.',
    thresholds: 'неуспели задаци у оквиру {hours} х, heartbeat касни више од {seconds} с',
    severity: {
      critical: 'Критично',
      warning: 'Упозорење',
      unknown: 'Непознато'
    }
  },
  explorer: {
    title: 'Истраживач ресурса',
    root: 'Корен',
    empty: 'Ниједан ресурс у овом scopeu',
    previewHint: 'Изаберите објекат да бисте видели преглед',
    open: 'Отвори',

    // Il deep-link ?scope= delle liste CRUD (round #109), dall'esplora (#143).
    openScoped: 'Отвори листу у овом scopeu',
    kinds: {
      vm: 'VM',
      vmTemplate: 'VM шаблон',
      ct: 'CT',
      ctTemplate: 'CT шаблон',
      app: 'Апликација',
      overlayNetwork: 'Overlay мрежа',
      networkService: 'Мрежни сервис',
      fabric: 'Fabric',
      subnet: 'Подмрежа',
      storage: 'Storage pool',
      disk: 'Диск',
      catalogFile: 'Датотека каталога',
      ociRegistry: 'OCI registry',
      ociImage: 'OCI слика',
      cephCluster: 'Ceph кластер',
      backupDestination: 'Одредиште бекапа',
      user: 'Корисник',
      group: 'Група',
      role: 'Улога',
      credential: 'Акредитив',
      tag: 'Таг',
      proximityRule: 'Правило близине'
    }
  },
  tags: {
    title: 'Тагови',
    empty: 'Нема тагова',
    add: 'Додај таг',
    remove: 'Уклони',
    name: 'Таг',
    value: 'Вредност',
    save: 'Сачувај',
    saveError: 'Није могуће сачувати тагове',
    loadError: 'Није могуће учитати речник тагова',
    noVocabulary: 'Ниједан таг није доступан за овај тип ресурса',

    // A single-valued tag already set answers 409: the replacement is always
    // explicit — never an implicit substitution (design, ratified 2026-07-27).
    overwrite: 'Замени тренутну вредност',

    // Sistema > Tag, the vocabulary surface.
    createTitle: 'Креирајте таг',
    editTitle: 'Измените таг',
    nameHint: 'Слова, цифре, тачке, цртице и доње црте — без ":" и без "/"; префикс tvirt- резервисан је за платформу',
    cardinality: 'Кардиналност',
    cardinalitySingle: 'Једна вредност',
    cardinalityMultiple: 'Више вредности',
    cardinalityHint: 'Са једном вредношћу, поновна додела тага тражи да се вредност замени',
    autoCreate: 'Аутоматско креирање вредности',
    autoCreateOn: 'При додели',
    autoCreateOff: 'Само декларисане',
    autoCreateHint: 'Укључено: додела нове вредности је креира. Искључено: додељују се само декларисане вредности',
    values: 'Вредности',
    noValues: 'Ниједна вредност није декларисана',
    addValue: 'Додај вредност',
    duplicateValue: 'Дуплирана вредност',
    kinds: 'Типови ресурса',
    kindsAll: 'Све',
    kindsPlaceholder: 'Све',
    kindsHint: 'Оставите празно да бисте дозволили сваки тип ресурса који се може таговати',
    systemChip: 'Систем',
    deleteCascade: 'Уклони и додељивања',
    deleteCascadeHint: 'Ознака која је још додељена неком ресурсу се одбија: са овом опцијом вредности и сва додељивања одлазе заједно са ознаком.'
  },
  scopes: {
    title: 'Scope',
    createTitle: 'Креирајте scope',
    editTitle: 'Преименујте scope',
    path: 'Путања',
    segment: 'Сегмент',
    segmentHint: 'Мала слова, цифре и цртице (DNS-1123)',
    parent: 'Родитељ',
    rootChip: 'Корен',
    preview: 'Нови scope',
    pickLabel: 'Scope',
    pickHint: 'Где објекат живи у стаблу кластера — корен или vDC унутар њега.',
    ociCache: 'OCI cache (override)',
    appEphemeral: 'Ефемерни pool за App (override)',
    inherit: 'Наслеђује',
    inheritsFrom: 'Наслеђује од',
    inheritsCluster: 'Наслеђује подразумевано за кластер',
    inheritsNone: 'Наслеђује — нема ефективног poola',
    failoverProtection: 'Заштита при деградацији',
    networkWeight: 'Мрежна тежина',
    networkCeil: 'Мрежни плафон (Мбпс)',
    protectionProtected: 'Заштићен',
    protectionExpendable: 'Потрошив при деградацији',
    protectionDefault: 'Подразумевано за кластер'
  },

  // Sistema > Informazioni (round #124, 2026-07-31): versioni piattaforma
  // nella flotta (al massimo due mid-upgrade), componenti per nodo, manuale
  // PDF servito localmente e card licenza inglobata.
  sysinfo: {
    summary: 'Верзије платформе у кластеру, компоненте сваког чвора, администраторски приручник и лиценца.',
    platformTitle: 'TVirt платформа',
    platformSubtitle: 'Верзије посматране на чворовима кластера',
    versionOnNodes: '{version} — чворова: {n}',
    versionOnOneNode: '{version} на 1 чвору',
    mixedVersions: 'Више од једне верзије платформе у кластеру — очекивано само док је надоградња у току (највише две).',
    tooManyVersions: 'Више од две верзије платформе у кластеру — то се не очекује никада, чак ни током надоградње: проверите чворове испод.',
    unreportedNodes: 'Још нема извештаја о верзијама од: {nodes}',
    noVersionsYet: 'Ниједан чвор још није пријавио своје верзије.',
    nodesUnavailable: 'Листа чворова није видљива са вашим дозволама — верзије платформе није могуће приказати.',
    colNode: 'Чвор',
    manualTitle: 'Администраторски приручник',
    manualSubtitle: 'Локална копија, коју служи овај кластер',
    manualBody: 'Комплетан TVirt приручник у PDF-у, који платформа служи директно — доступан и у air-gapped окружењима.',
    manualLink: 'Администраторски приручник (PDF)',
    apiExplorerTitle: 'API прегледач',
    apiExplorerSubtitle: 'OpenAPI уговор, доступан за преглед',
    apiExplorerBody: 'Комплетан OpenAPI уговор платформе — свака рута, шема и код одговора — доступан за преглед из прегледача, послужен кроз овај чвор.',
    apiExplorerLink: 'Истражи API',
    kubeTitle: 'Компатибилност са Кубернетесом',
    kubeSubtitle: 'кубецтл и његови алати, испред нативног API-ја',
    kubeBody: 'TVirt KubeCompat пројектује Подове, Deploymente, Сервисе, namespace-ove, чворове и догађаје у Кубернетес дијалект — само за читање, плус брисање Deploymenata. Сваки позив пролази кроз нативни API са твојим дозволама: у кубецонфиг-у користи app токен као беарер.',
    kubeEndpoint: 'Endpoint за кубецтл',
    kubeStatusActive: 'Активан — Кубернетес {version}',
    kubeStatusMissing: 'Није инсталиран на овом чвору (пакет trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Инсталиран, али не одговара — провери јединицу trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Провера…'
  },

  // Licensing (round 2026-07-29): la pagina della licenza a sottoscrizione.
  licensing: {
    title: 'Лиценца кластера',
    subtitle: 'Лиценца по претплати — највише једна по кластеру',
    absentTitle: 'Ниједна лиценца није регистрована',
    absentBody:
      'Без важеће лиценце кластер одбија да покреће нове виртуелне машине (упаљени VM-ови остају упаљени). Региструјте product key који сте добили уз претплату.',
    registerButton: 'Региструј лиценцу',
    removeButton: 'Уклони лиценцу',
    state: {
      ok: 'Важећа',
      limitExceeded: 'Лимит прекорачен',
      expired: 'Истекла'
    },
    productKeyLabel: 'Product key',
    basisLabel: 'Основа лимита',
    basis: {
      concurrentVms: 'Истовремено упаљени VM-ови',
      physicalCores: 'Физичка језгра (укупно за кластер)'
    },
    limitLabel: 'Лимит',
    usageLabel: 'Тренутна употреба',
    usageOf: '{used} од {limit}',
    usagePartial: 'делимичан збир — чворова без посматране CPU топологије: {n}',
    usageUnknown: 'тренутно се не може очитати',
    expiresLabel: 'Истек',
    neverExpires: 'никада',
    registeredLabel: 'Регистрована',
    gateNote:
      'Са одсутном, истеклом или прекораченом лиценцом кластер одбија да покреће НОВЕ виртуелне машине. Упаљени VM-ови остају упаљени, а HA рестартовања нису погођена.',
    devStage:
      'Развојна фаза: product key се прихвата такав какав је, заједно са овде декларисаним лимитима; валидација потписаним кључем стиже у будућем издању.',
    dialogTitle: 'Региструјте лиценцу',
    dialogExpiresHelp: 'Празно = лиценца никада не истиче',
    dialogSubmit: 'Региструј',
    dialogError: 'Није могуће регистровати лиценцу.',
    removeTitle: 'Уклоните лиценцу',
    removeBody:
      'Кластер ће остати БЕЗ ЛИЦЕНЦЕ: нове виртуелне машине ће одбијати да се покрену док се једна не региструје. Упаљени VM-ови остају упаљени.',
    removeConfirm: 'Уклони',
    removeError: 'Није могуће уклонити лиценцу.'
  },
  rbac: {
    tabRoles: 'Улоге',
    tabGrants: 'Доделе',
    rolesTitle: 'Улоге',
    createRoleTitle: 'Креирајте улогу',
    editRoleTitle: 'Измените улогу',
    nameHint: 'Мала слова, цифре и цртице; префикс tvirt- је резервисан',
    systemChip: 'Систем',
    permissions: 'Дозволе',
    permissionsPlaceholder: 'Додајте дозволу…',
    includedRoles: 'Укључене улоге',
    includedRolesPlaceholder: 'Додајте улогу…',
    grantsTitle: 'Доделе',
    createGrantTitle: 'Креирајте доделу',
    principal: 'Principal',
    principalKind: 'Тип principala',
    principalUser: 'Корисник',
    principalGroup: 'Група',
    role: 'Улога',
    grantRight: 'Делегирање',
    grantRightChip: 'Може да делегира',
    grantRightLabel: 'Са правом делегирања (прималац може ову улогу даље да делегира)',
    effective: 'Ефективна',
    notEffective: 'Није ефективна',
    createdAt: 'Креирана',
    scopeHint: '/path тачно, /path/* рекурзивно — доделе се сидре на монтирани корен (/* није могуће доделити)'
  },
  groups: {
    title: 'Групе',
    createTitle: 'Креирајте групу',
    nameHint: 'Мала слова, цифре и цртице; јединствено унутар scopea',
    members: 'Чланови',
    membersTitle: 'Чланови',
    membersPlaceholder: 'Додајте корисника…',
    noMembers: 'Нема чланова',
    realmMappings: 'Реалм мапирања',
    realmMappingsTitle: 'Реалм мапирања',
    realmMappingsHint:
      'Чему ова група одговара у сваком спољном реалму. Чланство се чита из директоријума при пријави: група из директоријума коју нико овде не мапира игнорише се, а угнежђивање се не разрешава — изравнајте га на страни директоријума.',
    realm: 'Реалм',
    externalGroup: 'Спољна група',
    addRealmMapping: 'Додај мапирање',
    removeRealmMapping: 'Уклони мапирање',
    noRealmMappings: 'Нема реалм мапирања',

    // Dialog di creazione a sezioni (round realm-wizard, 2026-08-03): Generale
    // più la superficie di mappatura coi realm esterni, con l'empty state
    // parlante.
    sectionGeneral: 'Опште',
    mappingsNoRealms: 'Ниједан спољни реалм није конфигурисан — површина за мапирање се откључава чим реалм постоји.',
    mappingsNoRealmsLink: 'Отвори таб Реалмови и SSO',

    // L'obbligo MFA imposto dal gruppo (round #178 metà B): OR puro — un
    // gruppo può solo AGGIUNGERE l'obbligo, mai toglierlo.
    mfaRequired: 'MFA обавеза',
    mfaRequiredChip: 'Намеће MFA',
    mfaNotRequiredChip: 'Без обавезе',
    mfaRequiredHint:
      'Чист OR: група може да ДОДА обавезу другог фактора својим члановима — и спољним идентитетима, кроз своја реалм мапирања — али никада да је укине. Важи од следеће пријаве: отворене сесије се не затварају.'
  },
  users: {
    title: 'Корисници',
    createTitle: 'Креирајте корисника',
    editTitle: 'Измените корисника',
    username: 'Корисничко име',
    usernameHint: 'Мала слова, цифре, тачке и цртице',
    displayName: 'Приказано име',
    enabled: 'Омогућен',
    state: 'Стање',
    enabledChip: 'Омогућен',
    disabledChip: 'Онемогућен',
    lockedChip: 'Закључан',
    password: 'Лозинка',
    passwordSetChip: 'Постављена',
    mustChangeChip: 'Мора се променити',
    initialPassword: 'Почетна лозинка',
    initialPasswordHint: 'Корисник мора да је промени при првој пријави',
    lastLogin: 'Последња пријава',
    neverLoggedIn: 'Никада се није пријавио',
    setPasswordTitle: 'Поставите лозинку',
    setPasswordHint: 'Административна замена — захтева вашу лозинку (sudo режим) и обавезује корисника да је промени при следећој пријави.',
    operatorPassword: 'Ваша лозинка',
    unlock: 'Откључај налог',
    revokeTitle: 'Опозовите сесије',
    revokeBody: 'Све активне сесије овог корисника одмах се прекидају.',
    revokeIncludeTokens: 'Опозови и app токене',
    revokeConfirm: 'Опозови',

    // Dialog standard (round #156): dettagli completi, tab account/sicurezza.
    tabAccount: 'Налог',
    tabSecurity: 'Безбедност',
    usernameImmutableHint: 'Корисничко име је идентитет налога — фиксирано при креирању',
    groups: 'Групе',
    noGroups: 'Нема група',
    mustChangePassword: 'Обавезна промена лозинке',
    failedAttempts: 'Неуспешни покушаји пријаве',
    lockedUntil: 'Закључан до',

    // Identity tabs (2026-08-03): Sistema > Utenti è diventata una sezione a
    // tab sul modello di /system/rbac — utenti, gruppi, realm esterni.
    tabUsers: 'Корисници',
    tabGroups: 'Групе',
    tabRealms: 'Реалмови и SSO',
    tabMfa: 'MFA',

    // Tab MFA (task #178): la vista del secondo fattore. Metà A — la tabella
    // per-utente su users.yaml; metà B (round contract, ratifiche 2026-08-04)
    // — il verdetto efficace con la provenienza, gli enrollment esterni con
    // lo stato orfano e i gruppi che impongono l'obbligo.
    mfa: {
      title: 'Други фактор (MFA)',
      methodsTitle: 'Доступне методе',
      methodsSubtitle: 'Оно што ова инсталација уме да верификује као други фактор',
      methodsError: 'Није могуће учитати регистар метода',
      builtinChip: 'Уграђен',
      enrollableChip: 'Enrollment у TVirt-у',
      delegatedChip: 'Управљан споља',
      state: 'Стање',
      stateActive: 'Активан',
      statePending: 'Чека enrollment',
      stateNone: 'Без enrollmenta',
      required: 'MFA обавеза',
      requiredChip: 'Обавезан',
      notRequiredChip: 'Није обавезан',
      enrolledAt: 'Enrollment од',
      enrolledMethods: 'Уписане методе',
      noMethods: 'Нема enrollmenta',
      codesRemaining: 'Преостали кодови за опоравак',
      resetTitle: 'Ресетујте други фактор',
      resetHint:
        'Enrollment и сви кодови за опоравак се бришу: при следећој пријави корисник пролази enrollment изнова, од нуле. MFA обавеза остаје каква јесте — администратор никада не поставља тајну, само је брише.',
      resetConfirm: 'Ресетуј',
      resetError: 'Није могуће ресетовати други фактор',
      empty: 'Још нема ниједног управљаног корисника — налози се појављују овде чим постоје, сваки са својим стањем другог фактора.',

      // Metà B (round #178): provenienza del verdetto efficace, enrollment
      // esterni con lo stato orfano, gruppi che impongono l'obbligo.
      viaSelf: 'Лично',
      viaSelfHint: 'Лични допринос налога (његов flag) — једини део који оловка мења.',
      viaGroupHint: 'Обавеза наслеђена од ове групе: уклањање личног flaga не ослобађа корисника — делује се на групу, у табу Групе.',
      subject: 'Идентитет',
      lastSeenAt: 'Последња потврда',
      enrollmentPending: 'На чекању',
      orphanChip: 'Сироче',
      orphanDirectoryMiss: 'Идентитет више није у директоријуму',
      orphanRealmRemoved: 'Реалм је уклоњен из TVirt-а',
      orphanedAt: 'Сироче од',
      directoryUuid: 'UUID у директоријуму',
      externalTitle: 'Спољни enrollmenti',
      externalEmpty: 'Још нема спољних enrollmenta — настаје при првој пријави идентитета из директоријума под MFA обавезом.',
      orphanHelp:
        'Осиротели enrollment никада се не брише сам од себе: то је безбедносни материјал — остаје због аудита и, ако се идентитет поново појави у директоријуму, поново налази свој фактор. Једини излаз је административни reset.',
      visibilityHint: 'Спољни enrollmenti живе у корену кластера: види их само онај ко има user.read над целим стаблом.',
      orphanResetHint:
        'Осиротели ред уклања се заувек: нико га више не потражује. Ако се идентитет икада врати у директоријум, проћи ће enrollment изнова, од нуле.',
      enforcingTitle: 'Групе које намећу MFA',
      enforcingSubtitle:
        'Сидро обавезе за спољне идентитете је група: њена реалм мапирања кажу до које популације директоријума допире. Спољни enrollment настаје при првој пријави обавезаног корисника.',
      enforcingEmpty: 'Ниједна група не намеће MFA — обавеза се укључује на групи, из таба Групе.',
      enforcingError: 'Није могуће учитати групе које намећу MFA'
    }
  },
  realms: {
    title: 'Реалмови за аутентификацију',
    createTitle: 'Креирајте реалм',
    editTitle: 'Измените реалм',
    name: 'Реалм',
    nameHint: 'Домен који корисници куцају после @ (example.com) — непроменљив након креирања',
    nameImmutableHint: 'Име реалма утиснуто је у сваку сесију и сваки ред аудита који га је икада именовао — преименовање би преписало историју',
    kind: 'Тип',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC и SAML стижу у наредним рундама — данас је реалм LDAPv3 директоријум',

    // Semi-wizard di creazione (round realm-wizard, 2026-08-03): le card dei
    // tipi del passo 1 — ldap vivo, oidc/saml card in roadmap (mai un form
    // senza un backend dietro).
    kindCategory: 'Тип реалма',
    kindSelectHint: 'Изаберите тип директоријума над којим ће овај реалм да аутентификује.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Корисничко име и лозинка проверени bindom на LDAPv3 директоријуму — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on из browsera делегиран OpenID Connect identity provideru — стиже у наредним рундама.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Пословни single sign-on са SAML 2.0 асерцијама — стиже у наредним рундама.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Омогућен',
    urls: 'Сервери директоријума',
    urlsHint: 'Један ldap:// или ldaps:// URL у сваком реду (1–8), пробају се редом — failover, никада балансирање',
    startTls: 'StartTLS',
    verifyCertificate: 'Провери сертификат',
    cleartextWarning: 'Без ldaps:// или StartTLS-а bind лозинка прелази мрежу у чистом тексту — прихватљиво у лабораторији, никада у продукцији.',
    noVerifyWarning: 'Непроверена TLS сесија не аутентификује никога: искључите проверу само према директоријуму који не можете поправити.',
    caCertificate: 'CA сертификат (PEM)',
    caCertificateHint: 'Опциони CA bundle пинован за TLS/StartTLS handshake овог реалма; празно га уклања',
    caCertificatePinned: 'Пинован',
    connectTimeout: 'Timeout (секунде)',
    connectTimeoutHint: 'Рок за конекцију и захтев по URL-у (1–60); по истеку се проба следећи URL',
    bindDn: 'Bind DN',
    bindDnHint: 'Сервисни налог који извршава претрагу корисника; празно = анонимни search bind (AD га одбија)',
    anonymousBind: 'Анонимни search bind',
    bindCredential: 'Bind лозинка (keystore)',
    bindCredentialHint: 'Један usernamePassword унос у keystoreu са bind лозинком — тајна никада не живи на реалму',
    bindCredentialNone: 'Ниједна (анонимни bind)',
    bindCredentialEmpty: 'Још нема usernamePassword уноса у keystoreu — креирајте један у Систем > Акредитиви за bind лозинку.',
    baseDn: 'Base DN',
    baseDnHint: 'Подстабло од којег креће претрага корисника (DC=example,DC=com)',
    userFilter: 'Кориснички филтер',
    userFilterHint: '%у се замењује локалним делом пријаве, уз RFC 4515 escape; не-AD директоријуми типично траже (&(objectClass=inetOrgPerson)(uid=%у))',
    memberOfAttribute: 'memberOf атрибут',
    memberOfAttributeHint: 'Чита се само једном, при пријави — немапиране групе се игноришу, угнежђивање се не разрешава',
    uuidAttribute: 'UUID атрибут',
    uuidAttributeHint: 'Непроменљиви UUID унутар реалма (objectGUID на AD-у, entryUUID на OpenLDAP-у) — утиснут у аудит поред korisnik@realm',
    displayNameAttribute: 'Атрибут приказаног имена',
    displayNameAttributeHint: 'Користи се за поздрав кориснику; ако га нема, користи се име за пријаву',
    sudoHint: 'Уписи на реалмове су sudo-заштићени: реалм је улазна врата у платформу',
    deleteBody: 'Мапирања група реалма одлазе са њим; сесије које је аутентификовао остају живе до истека — обрисани реалм просто више не прима никога новог.',
    tabConnection: 'Конекција',
    tabDirectory: 'Директоријум',
    testTitle: 'Тест конекције',
    testHint: 'Конфигурациона сонда, никада аутентификација: повезује се, ради bind сервисним налогом и — са корисничким именом — извршава кориснички филтер.',
    testUsername: 'Корисничко име (опционо)',
    testUsernameHint: 'Локални део над којим се извршава кориснички филтер — 1 погодак је здрав одговор',
    testRun: 'Покрени тест',
    testError: 'Није могуће покренути сонду',
    testReachable: 'Директоријум доступан, сервисни bind прихваћен',
    testUnreachable: 'Директоријум НИЈЕ доступан',
    matchedOne: 'Кориснички филтер је нашао тачно 1 унос — здрав одговор.',
    matchedNone: 'Кориснички филтер није нашао ниједан унос: филтер или base DN је погрешан.',
    matchedMany: 'Кориснички филтер је нашао више уноса ({count}): није селективан, па би пријаве биле двосмислене (одбијене).',
    mappingsPointer: 'Чему спољна група одговара јесте својство TVirt групе (њена реалм мапирања): тачка истине живи у табу Групе.',
    mappingsPointerLink: 'Отвори таб Групе',
    rootHomeHint: 'Идентитети спољног реалма живе у корену кластера, никада у vDC-у: дозволе се додељују тамо где су потребне, путем додела — на групи или директно на кориснику, баш као и за домаће кориснике.'
  },
  credentials: {
    title: 'Акредитиви',
    createTitle: 'Креирајте акредитив',
    editTitle: 'Измените акредитив',
    kind: 'Тип',
    kindUsernamePassword: 'Username и лозинка',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (Ceph идентитет)',
    kindHintUsernamePassword: 'Непроменљиво. За CIFS/SMB storage — налог за монтирање чију тајну worker користи у тренутку монтирања.',
    kindHintIscsiChap: 'Непроменљиво. За iSCSI CHAP аутентификацију — username = CHAP име, secret = CHAP тајна.',
    kindHintNvmeDhchap: 'Непроменљиво. За DH-HMAC-CHAP на NVMe over Fabrics — secret = DHHC-1:xx:… blob; username је само ознака.',
    kindHintCephx: 'Непроменљиво. За Ceph клијенте — username = име клијента (client.…), secret = base64 кључ.',
    kindImmutableHint: 'Тип је непроменљив након креирања — промена значи нови акредитив.',
    username: 'Корисничко име',
    usernameChap: 'CHAP име',
    usernameNvme: 'Ознака',
    usernameCephx: 'Име клијента',
    usernameHint: 'Опциони налог којем тајна припада',
    usernameHintChap: 'CHAP име којим се initiator аутентификује',
    usernameHintNvme: 'Transport је не користи — слободна ознака за вашу евиденцију',
    usernameHintCephx: 'Име cephx клијента — префикс client. се толерише',
    secret: 'Тајна',
    secretHint: 'Само за упис: користе је конзументи, никада се више не приказује.',
    secretHintNvmeDhchap: 'Само за упис: хост DH-HMAC-CHAP тајна у канонском облику DHHC-1:xx:… — користе је конзументи, никада се више не приказује.',
    secretHintCephx: 'Само за упис: base64 cephx кључ — користе га конзументи, никада се више не приказује.',
    secretEditHint: 'Оставите празно да тајна остане иста — попуњавање је ротира.',
    createdAt: 'Креиран',
    inUseError: "На '{name}' се позива конфигурација неког storagea — прво га тамо откачите.",
    nameHint: 'Мала слова, цифре и цртице (DNS-1123); јединствено по scopeu',

    // Dialog di sola rotazione (round #156): il segreto non ha mai la matita inline.
    rotateTitle: 'Ротирајте тајну',
    rotateHint: 'Само за упис: нова тајна замењује сачувану — конзументи је преузимају при следећем монтирању.',

    // Round #159 (PKI): i tab Certificati e CA.
    tabSecrets: 'Тајне',
    tabCertificates: 'Сертификати',
    tabAuthorities: 'Сертификациона тела',
    certificatesTitle: 'Сертификати',
    authoritiesTitle: 'Сертификациона тела',
    caCreateTitle: 'Нови CA',
    certCreateTitle: 'Нови сертификат',
    caMode: 'Извор',
    caModeGenerate: 'Генериши са TVirt-ом',
    caModeImport: 'Увези (кључ + сертификат)',
    certMode: 'Извор',
    certModeIssue: 'Издај од CA из keystorea',
    certModeImport: 'Увези (кључ + сертификат)',
    issuingCa: 'CA издавалац',
    issuingCaHint: 'Сертификат настаје у scopeu тог CA, са забележеним parentom',
    noCasHint: 'Још нема ниједног CA у keystoreu — прво генеришите или увезите један у табу CA',
    commonName: 'Цоммон name (CN)',
    commonNameCaHint: 'Subject тог CA: слова, цифре, размак, тачка, доња црта, цртица',
    commonNameCertHint: 'OpenVPN идентификује клијенте по CN-у — држите га јединственим унутар CA',
    days: 'Важење (дана)',
    daysCaHint: '1–7300 дана; 3650 (10 година) је подразумевано',
    daysCertHint: '1–3650 дана; 365 је подразумевано',
    keyType: 'Тип кључа',
    keyTypeHint: 'EC P-256 је подразумеван; RSA за legacy конзументе',
    usage: 'Намена',
    usageClient: 'Клијент (clientAuth)',
    usageServer: 'Сервер (serverAuth)',
    usageHint: 'Extended key usage за који се сертификат издаје',
    san: 'Алтернативна имена (SAN)',
    sanHint: 'Одвојена зарезом; IP литерали постају IP: уноси, остало DNS:',
    keyPem: 'Приватни кључ (PEM)',
    keyPemHint: 'Само за упис: чува се у keystoreu, никада се више не приказује',
    certPem: 'Сертификат (PEM)',
    certPemHint: 'Јавни сертификат који се упарује са кључем',
    certPemCaHint: 'CA сертификат који се упарује са кључем (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Издавалац',
    parentCa: 'CA издавалац',
    parentCaImported: 'Увезен — издат ван TVirt-а',
    serial: 'Серијски број',
    fingerprint: 'Fingerprint (SHA-256)',
    validFrom: 'Важи од',
    validUntil: 'Важи до',
    expiry: 'Истек',
    expired: 'Истекао',
    expiresInDays: 'Истиче за {days} d',
    revoked: 'Опозван',
    revokedAtLabel: 'Опозван дана',
    revokeTitle: 'Опозовите сертификат',
    revokeAction: 'Опозови',
    revokeWarning: 'Опозив је коначан: серијски број улази у CRL CA издаваоца и сваки конзумент који одбија опозване сертификате (OpenVPN пре свих) одбациће овај. Не постоји un-revoke.',
    exportPem: 'Извези PEM',
    exportChain: 'Извези bundle ланца',
    exportCrl: 'Извези CRL',
    materialImmutableHint: 'X.509 материјал је непроменљив — поново издајте или поново увезите',
    caInUseError: "'{name}' још има живе издате сертификате (или се неки storage позива на њега) — прво их опозовите или обришите."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Распоређивање, доступност и афинитет — где раде VM-ови кластера и да ли треба да буду упаљени',
    loadError: 'Proximity панелу је потребан store кластера — стање флоте тренутно није доступно',
    config: {
      title: 'Конфигурација',
      subtitle: 'Политика распоређивања на нивоу кластера',
      save: 'Сачувај',
      saveError: 'Конфигурација је одбијена',
      strategy: 'Стратегија избора',
      strategy_leastUsedResources: 'Најмање искоришћени ресурси',
      strategy_leastVms: 'Најмање VM-ова',
      strategy_random: 'Насумично',
      strategyLeastUsedResourcesHint: 'Међу валидним кандидатима, чвор са највише преосталог употребљивог RAM-а (посматрано укупно − резерва хоста − упаљени VM-ови), а нерешено решава vCPU заузеће. Детерминистичка при једнаким подацима.',
      strategyLeastVmsHint: 'Међу валидним кандидатима, чвор са најмање упаљених VM-ова; нерешено се решава по имену чвора. Детерминистичка при једнаким подацима.',
      strategyRandomHint: 'Униформно насумично међу валидним кандидатима.',
      liveness: 'Праг живости чворова (секунде)',
      livenessHint: 'Члан који ћути дуже од прага је недоступан: искључен је из распоређивања и — ако није у одржавању — HA decider га сматра мртвим, ограђује га и рестартује његове HA VM-ове другде.',
      decider: 'HA decider',
      deciderNone: 'још није изабран'
    },
    nodesTitle: 'Чворови',
    nodesSubtitle: 'Живост и емпиријски капацитет — употребљив RAM = укупно − база − заузето',
    nodeCol: 'Чвор',
    stateCol: 'Стање',
    ramCol: 'RAM (укупно − база − заузето)',
    usableCol: 'Употребљиво',
    vmsCol: 'Оптерећење',
    neverSeen: 'никад виђен',
    freshChip: 'доступан',
    staleChip: 'недоступан',
    attestedChip: 'атестиран као угашен',
    ramFormula: 'укупно − база − заузето',
    haTitle: 'Висока доступност',
    haSubtitle: 'VM-ови са HA flagom су „увек упаљени”: TVirt их рестартује после сваког заустављања које није затражено — исти чвор уз backoff, други чвор када њихов умре (само дељени storage).',
    haNone: 'Ниједан VM још нема HA flag — омогућите га овде или у детаљима VM-а.',
    haVmCol: 'Виртуелна машина',
    haStateCol: 'Стање',
    haRestartsCol: 'HA рестартовања',
    haLastEventCol: 'Последњи догађај',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'HA измена је одбијена',
    rules: {
      title: 'Правила афинитета',
      createTitle: 'Ново правило близине',
      editTitle: 'Измените правило',
      nameHint: 'Мала слова, цифре и цртице (DNS ознака)',
      vms: 'Виртуелне машине',
      vmsHint: 'Најмање два VM-а — правило везује где једни раде у односу на друге',
      type: 'Тип',
      affinity: 'Афинитет (заједно)',
      antiAffinity: 'Анти-афинитет (одвојено)',
      typeAffinityHint: 'VM-ови треба да раде на ИСТОМ чвору.',
      typeAntiAffinityHint: 'VM-ови треба да раде на РАЗЛИЧИТИМ чворовима — класичан HA пар.',
      mode: 'Режим',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Прекршаји одбијају операцију (покретање, миграција, failover) уз речиту грешку.',
      modeSoftHint: 'Преференција, никада не блокира: распоред у прекршају наставља се уз видљиво упозорење.',
      satisfied: 'Распоред',
      satisfiedYes: 'поштован',
      satisfiedNo: 'прекршен',

      // Dialog standard (round #156): le violazioni hanno la loro riga, non un tooltip.
      violations: 'Прекршаји',
      noViolations: 'Ниједан'
    },
    events: {
      title: 'HA догађаји',
      subtitle: 'Дневник доступности — рестартовања, fencing, failoveri и поштени прескоци',
      none: 'Још ништа.',
      when: 'Када',
      kind: 'Догађај',
      target: 'Објекат',
      detail: 'Детаљ',
      kindRestarted: 'HA restart',
      kindGaveUp: 'предаја (crash loop)',
      kindNodeAttested: 'чвор ограђен',
      kindFailedOver: 'failover',
      kindNoCandidate: 'нема кандидата',
      kindStorageLocalSkip: 'прескочено (локални storage)',
      kindZombieFenced: 'зомби прекинут'
    }
  }
}
